module.exports = __webpack_public_path__ + "img/GAME_GLACIER.b342a7cc.png";